import React, { useState } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { AccessTime as AccessTimeIcon } from '@mui/icons-material';
import moment from 'moment';

interface TimeGridRowProps {
    hour: number; // The hour for this row (0-23)
    availability: string // Array of time ranges, e.g., ["01:00-03:00", "05:00-06:00"]
    mergedAvailability: string[]
    selectedDay: null | string;
    onClick?: (state: "available" | "unavailable" | "halfStartAvailable" | "halfEndAvailable", newRange: string) => void;
}

const TimeGridRow: React.FC<TimeGridRowProps> = ({ availability, mergedAvailability, selectedDay, onClick, hour }) => {
    const [state, setState] = useState("unavailable");
    
    React.useEffect(() => {
        if (availability === undefined || availability === "") {
            setState("unavailable");
        } else {
            setState((availability.split("-")[0].includes(":30") ? "halfEndAvailable" : availability.split("-")[1].includes(":30") ? "halfStartAvailable" : "available"));
        }
      }, [availability])
    
    const handleClick = () => {
        let newState: "available" | "unavailable" | "halfStartAvailable" | "halfEndAvailable" = state === "available" ? "unavailable"
            : state === "unavailable" ? "halfStartAvailable"
                : state === "halfStartAvailable" ? "halfEndAvailable"
                    : "available";
        setState(newState);
        if (onClick) {
            let newRange: string = hour < 10 ? `0${hour}:00-${hour + 1 < 10 ? `0${hour + 1}` : hour + 1}:00` : `${hour}:00-${hour + 1}:00`;
            if (newState === "halfStartAvailable") {
                newRange = hour < 10 ? `0${hour}:00-0${hour}:30` : `${hour}:00-${hour}:30`;
            } else if (newState === "halfEndAvailable") {
                newRange = hour < 10 ? `0${hour}:30-${hour + 1 < 10 ? `0${hour + 1}` : hour + 1}:00` : `${hour}:30-${hour + 1}:00`;
            }
            onClick(newState, newRange);
        }
    }

    return (
        <Box sx={{
            paddingLeft: 2,
            cursor: 'pointer', bgcolor: state === 'available' ? 'success.light' : 
            state === 'halfStartAvailable' || state === 'halfEndAvailable' ? 'info.light' : 'grey.300', '&:hover':
                { boxShadow: 3, bgcolor: state === 'available' ? 'success.main' : 
                    state === 'halfStartAvailable' || state === 'halfEndAvailable' ? 'info.main' : 'grey.400' }
        }} onClick={handleClick}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1 }}>
                {/* Time Icon and Label */}
                <AccessTimeIcon fontSize="small" sx={{ color: 'text.primary'}} />
                <Divider orientation="vertical" flexItem sx={{ color: 'text.primary'}}/>
                <Typography variant="body2" sx={{ color: 'text.primary'}}>
                    {moment().startOf('day').add(hour, 'hours').format('h A')}
                </Typography>

                {/* Render chips for available time ranges */}
                <Typography variant='body2' component="span" fontWeight={700} sx={{ color: 'text.primary' }}>
                    {mergedAvailability.map((range) => {
                        if (
                          hour === parseInt(range.split('-')[0].split(':')[0]) ||
                          (range.split('-')[0].includes(':30') && hour === parseInt(range.split('-')[0].split(':')[0])) ||
                          (range.split('-')[1].includes(':30') && hour === parseInt(range.split('-')[1].split(':')[0])) ||
                          (hour < parseInt(range.split('-')[1].split(':')[0]) && hour > parseInt(range.split('-')[0].split(':')[0]))
                        ) {
                          return (
                            <span key={range}>
                              {`Available: ${range}`}
                            </span>
                          );
                        }
                        return null;
                      })}
                </Typography>
            </Box>
            <Divider sx={{ color:'background.default'}} />
        </Box>
    );
};

export default TimeGridRow;